import { Button, Descriptions, Space, Tag,message } from "antd";
import { MONTHS } from "../../defaults/utilities"
import {BsCalendar4,BsPersonSquare} from "react-icons/bs";
import { CheckOutlined, DeleteOutlined,CloseCircleOutlined } from "@ant-design/icons";
import { userStore } from "../../store/userStore";
import { useDeletePayroll, useDisApprovePayroll, usePayrollApproval, useSubmitPayroll } from "../../hooks/payroll/payrollQuery";



export default function PayrollConfiguration({config, onUpdate}){


    const currentUser = userStore(state=>state.user);

    const submitPayrollConfig = useSubmitPayroll()
    const deletePayrollConfig = useDeletePayroll();
    const approvePayrollConfig = usePayrollApproval();
    const disApprovePayrollConfig = useDisApprovePayroll();


    const handleSubmitConfig = async ()=>{
        console.log(config)
        const payload = {
            payrollConfig:config.id
        }
        const resp = await submitPayrollConfig(payload);
        message.success("Submitted successfully");
        onUpdate()
    }

    const handleDeleteConfig = async ()=>{
        await deletePayrollConfig(config.id);
        message.success("Payroll config deleted successfully");
        onUpdate()
    }

    const handleApproveConfig = async ()=>{
        const payload = {
            payrollConfig:config.id
        }
        await approvePayrollConfig(payload);
        message.success("Payroll Approved successfully")
        onUpdate()
    }

    const handleDisApproveConfig = async ()=>{
        const payload = {
            payrollConfig:config.id
        }
        await disApprovePayrollConfig(payload);
        message.success("Payroll disApproved successfully")
        onUpdate()
    }

    return(
        <>
            <div style={{
                padding:"2em",
                marginTop:"1em",
                marginBottom:"1em",
                borderRadius:"1em",
                boxShadow:"3px 8px 17px 0px rgba(0,0,0,0.75)",
                minHeight:"70vh"
            }}>
                <div style={{
                }}>
                    <div>
                        <span style={{
                            color:"gray",
                            fontSize:"2em",
                            fontWeight:"bold"
                        }}>
                            Payroll Configuration
                        </span>
                        <div style={{
                            backgroundColor:"green",
                            marginTop:"0.2em",
                            padding:"0.3em",
                            width:"12em",
                            borderRadius:"5px",
                            display:"flex",
                            alignItems:"center",
                            color:"white"
                        }}>
                            <BsCalendar4 style={{
                                color:"white"
                            }}/>
                            <div style={{
                                marginLeft:"0.5em",
                                fontWeight:"bold",
                                display:"flex",
                                justifyContent:"space-evenly",
                                width:"60%"
                            }}>
                           <span>{MONTHS.find((m)=>m.value == config.yearMonth[1]).name}</span>

                           <span>{config.yearMonth[0]}</span>
                            </div>
                        </div>
                    </div>
                    <div style={{
                        display:"flex",
                        marginTop:"1em",
                        borderRadius:"1em",
                        backgroundColor:"lightgray",
                        paddingLeft:"1em",
                        paddingRight:"1em",
                        justifyContent:"space-between",
                        height:"5em",
                    }}>
                        <div style={{
                            padding:"0.2em"
                        }}>
                        <BsPersonSquare style={{
                            height:"60",
                            width:"60",
                            color:"white"
                        }}/>
                        </div>
                        <div style={{
                            marginLeft:"3em"
                        }}>
                        <Descriptions layout="vertical">
                            <Descriptions.Item label="Initiated By">{config?.creator?.name ?? "Payroll Officer"}</Descriptions.Item>
                            <Descriptions.Item label="email">{config?.creator?.email}</Descriptions.Item>
                        </Descriptions>
                        </div>
                    </div>
                    <div style={{
                        marginTop:"2em"
                    }}>
                        <Descriptions title="Details" bordered column={1}>
                            <Descriptions.Item label="Created On">
                                {new Date(config.creationTime).toDateString()}
                            </Descriptions.Item>
                            <Descriptions.Item label="Payroll Submitted">
                                {config.submitted  ? <Tag color="green">Submitted</Tag>:<Tag color="red">Not Yet Submitted</Tag>}
                            </Descriptions.Item>
                            <Descriptions.Item label="Final Approval status">
                                {config.finalApproved ?  <Tag color="green">Approved</Tag> : <Tag color="red">Not Approved</Tag>}
                            </Descriptions.Item>
                            <Descriptions.Item label="Rejected">
                                {config.rejected ? <Tag color="red">Rejected</Tag>:<Tag color="blue">Not Rejected</Tag>}
                            </Descriptions.Item>
                            <Descriptions.Item label="Current Approval Stage">
                                {config.payrollApprovalStage?.role ?? "None"}
                            </Descriptions.Item>
                            <Descriptions label="Approval List">
                                {config.approvedBy.length > 0 ? config.approvedBy.map((a,idx)=>(<Tag key={idx} color="green">{a}</Tag>)):
                                    <Tag color="yellow">No Approval yet</Tag>
                                }
                            </Descriptions>
                        </Descriptions>
                    </div>
                    <div style={{
                        marginTop:"2em",
                        display:"flex",
                        justifyContent:"flex-end"

                    }}>
                        <Space>
                        {
                        !config.submitted &&(<>
                        <Button type="primary" style={{
                            backgroundColor:"green"
                        }} onClick={handleSubmitConfig}>
                            <CheckOutlined/>
                            Submit
                        </Button>
                        <Button type="primary" style={{
                            backgroundColor:"red"
                        }} onClick={handleDeleteConfig}>
                            <DeleteOutlined/>
                            Delete
                        </Button>
                        </>)
                        }
                        {
                            !config.finalApproved && !config.rejected && config.nextApprovalStage && currentUser?.roles?.includes(config.nextApprovalStage.role) && (
                                <>
                                    <Button type="primary" style={{
                                        backgroundColor:"green"
                                    }} onClick={handleApproveConfig}>
                                        <CheckOutlined/>
                                        Approve as {config.nextApprovalStage.role}
                                    </Button>
                                    <Button type="primary" style={{
                                        backgroundColor:"red"
                                    }} onClick={handleDisApproveConfig}>
                                        <CloseCircleOutlined/>
                                        Reject
                                    </Button>
                                </>
                            )
                        }
                        </Space>
                    </div>
                </div>
            </div>
        </>
    )
}
